import sample from "Assets/svg/menu/project.svg";

export default {
  Category: [
    {
      menu_title: "sami_pricing",
      menu_icon: sample,
      path: "/admin/pricing",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_support",
      menu_icon: sample,
      path: "/admin/support",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_tickets",
      menu_icon: sample,
      path: "/admin/tickets",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_notices",
      menu_icon: sample,
      path: "/admin/notices",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_financial",
      menu_icon: sample,
      path: "/admin/financial",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_tools",
      menu_icon: sample,
      path: "/admin/tools",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    },
    {
      menu_title: "sami_statistics",
      menu_icon: sample,
      path: "/admin/statistics",
      authorize: true,
      checkVisible: false,
      keyStorage: "",
      userAccess: ["4"],
    }
  ],
};
